// All Environment varible add in this file
export const environment = {
  organization: 'Hmmngbrd Client',
  siteKey: '6LcuO9krAAAAAA4bzVj6v0pwCwNKY42M0EvHKdw9',
  secretKey: '6LcuO9krAAAAAIv69yyLNkJC3E45EnOJWM8tIAjN',
  imagePath: 'https://api.hmmngbrd.p2staging.us/',
  siteUrl: 'https://hmmngbrd.p2staging.us/',
  StorageURL: 'https://hmmngbrd.nyc3.cdn.digitaloceanspaces.com/',
  stripeKey:
    '',
  proPlanAmount: 20,
  videoImg: '',
  promocode: '',
  SOCKETURL: 'https://api.livinglegacy.me/socket',
  postCommentCount: 10,
  googleAuthClientId: '477366878959-cafucsoteaseju0lofei000bq0b7k6dd.apps.googleusercontent.com',
  GoogleReCaptcha: '6LcuO9krAAAAAA4bzVj6v0pwCwNKY42M0EvHKdw9',
  TextDecoder: 'Swe4g7c?UBm5Nrd96vhsVDtkyJFbqKMTm!TMw5BDRLtaCFAXNvbq?s4rGKQSZnUP',
  apiEndPoint: 'https://api.livinglegacy.me/',
  gDriveClientId: '666241510265-sc9hrthkbsf8ig6rjbm2b57brilkdgd8.apps.googleusercontent.com',
  gDriveDeveloperKey: 'AIzaSyCYsZ1YO8uidtO-bJSO2FnePtverYtwEvw',
  googleMapApiKey: 'AIzaSyDRLDXKrSBhvFh-yXE42-In7nPwQcTKUA8',
  AdminApiEndPoint: 'https://api.livinglegacy.me/admin',
  frontEndPoint: 'https://livinglegacydotme.web.app/', // <---
  pledgeOrigin: 'https://hello.pledge.to',
  RealmAppId: 'application-0-seifu',
  pledgePartnerKey: '8fe366251a82f3415fb0506bef6390db',
  pledgeApiKey: '420e78cafc33b684c9f21f425c3a84cf',
  mongodbStream: 'butterflyv2prod',
  // twilioNumber: '+19254773033',
  twilioNumber: '+X-XXXXXXXXX',

  dropBoxAppKey: '225cketkzbqqyn7',
}

// @ts-nocheck
export const environment_support = {
  organization: 'Pledge',
  apiEndPoint_staging: 'https://api.hmmngbrd.p2staging.us/api/get-organization',
  apiEndPoint_organization: 'https://api.hmmngbrd.p2staging.us/api/get-organization-page?page_id=',
  partnerKey_staging: '7d087db1f2f358fecd6258c31ab19363',
  api_key_staging: '57fd0acbac827bfb70e0240b903e5fa3',
  siteUrl: 'https://api-staging.pledge.to/',
  apiEndPoint: 'https://api.pledge.to/v1',
  partnerKey: '8fe366251a82f3415fb0506bef6390db',
  api_key: '420e78cafc33b684c9f21f425c3a84cf',
  ownerLimitForPledge: 4,
}
